import React, { useEffect, useRef, useState } from "react";
import "./ReportsView.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCertificate,
  faChartPie,
  faClose,
  faCopy,
  faEdit,
  faEye,
  faFile,
  faPen,
  faPenToSquare,
  faShare,
  faTrashCan,
  faUndo,
  faUpload,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const config = require("../../config.js");
const translations = {
  english: {
    name: "Name",
    company: "Company",
    email: "Email",
    category: "Category",
    language: "Language",
    year: "Year",
    filters: "Filters",
    selectLanguage: "Select Language",
    action: "Actions",
    null: "Null",
    fiscalYear: "Fiscal Year",
    status: "Status",
    report: "Report",
    third: "3rd Party",
    certificate: "Verification",
    documents: "Expert Report",
    visible: "Visible",
    deleteDocument: "Are you sure you want to delete this document?",
    showDocument: "Are you sure you want to show this document to company?",
    hideDocument: "Are you sure you want to hide this document to company?",
    deleteOk: "Document deleted!",
    deleteError: "Failed to delete!",
    uploadOk: "Upload successful!", 
    uploadError: "Upload failed.",
    reportOk: "report deleted successfully",
    reportDelete:"Are you sure you want to send it back to the assessments section?"
  },
  german: {
    name: "Name",
    company: "Unternehmen",
    email: "E-Mail",
    category: "Kategorie",
    language: "Sprache",
    year: "Jahr",
    filters: "Filter",
    selectLanguage: "Sprache wählen",
    action: "Aktionen",
    null: "Null",
    fiscalYear: "Geschäftsjahr",
    status: "Status",
    report: "Bericht",
    third: "Drittanbieter",
    certificate: "Verifikation",
    documents: "Sachverständigenbericht",
    visible: "Sichtbar",
    deleteDocument: "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?",
    showDocument: "Sind Sie sicher, dass Sie dieses Dokument dem Unternehmen zeigen möchten?",
    hideDocument: "Sind Sie sicher, dass Sie dieses Dokument vor dem Unternehmen verbergen möchten?",
    deleteOk: "Dokument gelöscht!",
    deleteError: "Löschen fehlgeschlagen!",
    uploadOk: "Upload erfolgreich!",
    uploadError: "Upload fehlgeschlagen.",
    reportOk: "Bericht erfolgreich gelöscht.",
    reportDelete: "Möchten Sie es wirklich an den Bewertungsbereich zurücksenden?"
  },
  czech: {
    name: "Jméno",
    company: "Společnost",
    email: "E-mail",
    category: "Kategorie",
    language: "Jazyk",
    year: "Rok",
    filters: "Filtry",
    selectLanguage: "Vyberte jazyk",
    action: "Akce",
    null: "Nil",
    fiscalYear: "Hospodářský rok",
    status: "Stav",
    report: "Zpráva",
    third: "Třetí strana",
    certificate: "Ověření",
    documents: "Odborná zpráva",
    visible: "Viditelné",
    deleteDocument: "Opravdu chcete smazat tento dokument?",
    showDocument: "Opravdu chcete tento dokument ukázat společnosti?",
    hideDocument: "Opravdu chcete tento dokument skrýt před společností?",
    deleteOk: "Dokument byl smazán!",
    deleteError: "Smazání selhalo!",
    uploadOk: "Nahrávání bylo úspěšné!",
    uploadError: "Nahrávání selhalo.",
    reportOk: "Zpráva byla úspěšně smazána.",
    reportDelete: "Jste si jistý/á, že to chcete poslat zpět do sekce hodnocení?"
},
  italian: {
    name: "Nome",
    company: "Azienda",
    email: "Email",
    category: "Categoria",
    language: "Lingua",
    year: "Anno",
    filters: "Filtri",
    selectLanguage: "Seleziona Lingua",
    action: "Azioni",
    null: "Nullo",
    fiscalYear: "Anno Fiscale",
    status: "Stato",
    report: "Rapporto",
    third: "Terza Parte",
    certificate: "Verifica",
    documents: "Rapporto Esperto",
    visible: "Visibile",
    deleteDocument: "Sei sicuro di voler eliminare questo documento?",
    showDocument: "Sei sicuro di voler mostrare questo documento all'azienda?",
    hideDocument: "Sei sicuro di voler nascondere questo documento all'azienda?",
    deleteOk: "Documento eliminato!",
    deleteError: "Eliminazione fallita!",
    uploadOk: "Caricamento riuscito!",
    uploadError: "Caricamento fallito.",
    reportOk: "Rapporto eliminato con successo.",
    reportDelete: "Sei sicuro di volerlo rispedire alla sezione assessments?"
  },
};

function ReportsExpertView() {
  const [Reports, setReports] = useState([]);
  const [thirds, setThirds] = useState([]);
  const [selectedThird, setSelectedThird] = useState("");
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const fileInputRef = useRef(null);

  const handleIconClick = (reportId, type) => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
      setSelectedType(type);
      if(type == "docs") {
        setSelectedDocument(reportId);
      } else {
        setSelectedCertificate(reportId);
      }
    }
  };

  const checkCertificate = async (reportId, val) => {
        try {
          const response = await fetch(
            config.env.API_BASE_URL + "/api/reports/" + reportId + "/showc/" + val,
            {
              method: "POST",
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
    
          if (response.ok) {
            fetchReports();
          } else {
          }
        } catch (error) {
        }
      };

  const deleteCertificate = async (reportId, type) => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + "/api/reports/" + reportId + "/" + type,
        {
          method: "DELETE",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (response.ok) {
        fetchReports();
        alert(lang.deleteOk);
      } else {
        alert(lang.deleteError);
      }
    } catch (error) {
      alert(lang.deleteError);
    }
  };

  const checkDocument = async (reportId, val) => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + "/api/reports/" + reportId + "/show/" + val,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (response.ok) {
        fetchReports();
      } else {
      }
    } catch (error) {
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log("File selected:", file.name);
      // Puoi gestire l'upload qui

      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await fetch(
          config.env.API_BASE_URL +
            "/api/reports/" +
            (selectedType == "docs" ? selectedDocument : selectedCertificate) +
            "/" + selectedType,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: formData,
          }
        );

        if (response.ok) {
          const result = await response.json();
          console.log("File successfully uploaded:", result);
          fetchReports();
          alert(lang.uploadOk);
        } else {
          console.error("Error uploading file:", response.statusText);
          alert(lang.uploadError);
        }

        setSelectedCertificate(null);
        setSelectedDocument(null);
        setSelectedType("");
      } catch (error) {
        setSelectedCertificate(null);
        setSelectedDocument(null);
        setSelectedType("");
        alert(lang.uploadError);
      }
    }
  };

  const fetchThirds = async () => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + "/api/users/third",
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setThirds(data);
      } else {
        console.error("Failed to fetch Thirds");
      }
    } catch (error) {
      console.error("Error fetching Thirds:", error);
    }
  };

  useEffect(() => {
    fetchThirds();
  }, []);

  const navigate = useNavigate();

  const fetchReports = async () => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + "/api/reports/experts",
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setReports(data);
        setFilteredAssessments(data);
      } else {
        console.error("Failed to fetch Reports");
      }
    } catch (error) {
      console.error("Error fetching Reports:", error);
    }
  };

  useEffect(() => {
    fetchReports(); // Fetch Reports on component mount
  }, []);

  const GoToAssessment = (reportId) => {
    navigate(`/reports/report/view/${reportId}`);
  };

  const GoToReport = (year,userId) => {
    navigate(`/reports?reportYear=${year}&userId=${userId}`);
  };

  const editThird = (reportId, thirdId) => {
    setSelectedThird(thirdId);
    setSelectedReport(reportId);
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + `/api/reports/experts/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.ok) {
        alert(lang.reportOk);
        fetchReports();
      } else {
        console.error("Failed to delete report");
      }
    } catch (error) {
      console.error("Error deleting report:", error);
    }
  };

  const getByStatus = (status) => {
    if (status == 0) return "Loaded";

    if (status == 1) return "Sent";

    if (status == 2) return "Assigned";

    if (status == 3) return "Certificated";
  };
  const [filteredAssessments, setFilteredAssessments] = useState([]);

  const calculateTable = () => {
    let newAssessments = Reports.filter((myAssessments) => {
      if (
        myAssessments.fiscalYear
          .toString()
          .toLowerCase()
          .includes(myFilters.fiscalYear.toString().toLowerCase()) &&
        myAssessments.status
          .toString()
          .toLowerCase()
          .includes(myFilters.status.toString().toLowerCase()) &&
        myAssessments.language
          .toString()
          .toLowerCase()
          .includes(myFilters.language.toString().toLowerCase()) &&

        (myAssessments.userId ? 
        myAssessments.userId && myAssessments.userId.name
          .toString()
          .toLowerCase()
          .includes(myFilters.name.toString().toLowerCase()) &&
        myAssessments.userId.companyName
          .toString()
          .toLowerCase()
          .includes(myFilters.companyName.toString().toLowerCase()) &&
        myAssessments.userId.email
          .toString()
          .toLowerCase()
          .includes(myFilters.email.toString().toLowerCase()) : true) &&
        (myAssessments?.thirdUserId?._id === myFilters.third ||
          !myFilters.third)
      ) {
        return true;
      } else {
        return false;
      }
    });
    setFilteredAssessments(newAssessments);
  };

  let myFilters = {
    fiscalYear: "",
    email: "",
    third: "",
    status: "",
    name: "",
    category: "",
    language: "",
    year: "",
    companyName: ""
  };

  const [currentLanguage] = useState(
    localStorage.getItem("language") || "english"
  );

  let lang = translations[currentLanguage];

  const setModal = (res) => {
    setSelectedThird("");
    setSelectedReport(null);
    fetchReports();
  };

  return (
    <>
      <div
        className="mt-5 Crud-main-container container"
        style={{ color: "#9C9CA5" }}
      >
        <div style={{ fontSize: "24px" }}>{lang.filters}</div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginTop: "16px",
            marginBottom: "16px",
            gap: "24px",
            paddingLeft: "12px",
            paddingRight: "12px",
            placeContent: "center",
          }}
        >
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.fiscalYear}
            </div>
            <input
              placeholder={lang.fiscalYear}
              type="number"
              onChange={(event) => {
                myFilters.fiscalYear = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.name}
            </div>
            <input
              placeholder={lang.name}
              onChange={(event) => {
                myFilters.name = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.company}
            </div>
            <input
              placeholder={lang.company}
              onChange={(event) => {
                myFilters.companyName = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.email}
            </div>
            <input
              placeholder={lang.email}
              onChange={(event) => {
                myFilters.email = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.language}
            </div>
            <input
              placeholder={lang.language}
              onChange={(event) => {
                myFilters.language = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.third}
            </div>
            <select
              onChange={(event) => {
                myFilters.third = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            >
              <option key={null} value={""}>
                {lang.null}
              </option>
              {thirds.map((third, idx) => (
                <option key={idx} value={third._id}>
                  {third.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <input
          type="file"
          style={{ display: "none" }}
          ref={fileInputRef}
          onChange={handleFileChange}
        />
        <table className="table Crud-main container">
          <thead>
            <tr className="Crud-thead-wrapper">
              <th scope="col">{lang.fiscalYear}</th>
              <th scope="col">{lang.name}</th>
              <th scope="col">{lang.company}</th>
              <th scope="col">{lang.email}</th>
              <th scope="col">{lang.language}</th>
              <th scope="col">{lang.report}</th>
              <th scope="col">{lang.third}</th>
              <th scope="col">{lang.documents}</th>
              <th scope="col">{lang.certificate}</th>
              <th scope="col">{lang.action}</th>
            </tr>
          </thead>
          <tbody>
            {filteredAssessments.slice().map((report) => (
              <tr key={report._id}>
                <td>{report.fiscalYear}</td>
                <td>{report.userId?.name}</td>
                <td>{report.userId?.companyName}</td>
                <td>{report.userId?.email}</td>
                <td>{report.language}</td>
                <td>
                  <FontAwesomeIcon
                    icon={faEye}
                    onClick={() => {
                      GoToAssessment(report._id);
                    }}
                  />

                  <FontAwesomeIcon
                      icon={faChartPie}
                      style={{marginLeft: "10px"}}
                      onClick={() => {
                          GoToReport(report.fiscalYear, report.userId._id);
                      }}
                  />
                </td>
                <td>
                  <div>
                      <FontAwesomeIcon
                        icon={faUserTie}
                        onClick={() => {
                          editThird(
                            report._id,
                            report.thirdUserId ? report.thirdUserId._id : null
                          );
                        }}
                      />

                    {report.thirdUserId && (
                      <span style={{ marginLeft: "10px" }}>
                        {report.thirdUserId.name}
                      </span>
                    )}
                  </div>
                </td>
                <td style={{ width: "110px"}}>
                  <FontAwesomeIcon
                    icon={faUpload}
                    onClick={() => handleIconClick(report._id, "docs")}
                  />
                  {report.document && (
                    <>
                      <a
                        style={{ marginLeft: "10px" }}
                        href={config.env.STORAGE_URL + report.document}
                        target="_blank"
                      >
                        <FontAwesomeIcon icon={faFile} />
                      </a>

                      <FontAwesomeIcon
                        style={{ marginLeft: "10px" }}
                        onClick={() => {
                          if (
                            window.confirm(
                              lang.deleteDocument
                            )
                          ) {
                            deleteCertificate(report._id, "docs");
                          }
                        }}
                        icon={faClose}
                      />
                      <input style={{ marginLeft: "10px" }} checked={report.show} value={report.show} type="checkbox" onChange={(e) => {
                        let val = report.show;
                        var text = report.show ? lang.hideDocument : lang.showDocument;
                        if (
                          window.confirm(text)
                        ) {
                          checkDocument(report._id, report.show ? false : true);
                        } else {
                          report.show = val;
                        }
                      }} />
                    </>
                  )}
                </td>
                <td style={{ width: "110px"}}>
                  {report.certificate && (
                    <>
                      <a
                        style={{ marginLeft: "10px" }}
                        href={config.env.STORAGE_URL + report.certificate}
                        target="_blank"
                      >
                        <FontAwesomeIcon icon={faCertificate} />
                      </a>
                    </>
                  )}
                </td>
                <td>
                  {report.status === 1 && (
                    <>
                      <FontAwesomeIcon
                        onClick={() => {
                          if (
                            window.confirm(
                              lang.reportDelete
                            )
                          ) {
                            handleDelete(report._id);
                          }
                        }}
                        className="icon trash"
                        icon={faUndo}
                      />
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {selectedThird != "" && (
          <ModalThird
            third={selectedThird}
            setModal={setModal}
            reportId={selectedReport}
            thirds={thirds}
          />
        )}
      </div>
    </>
  );
}

const ModalThird = ({ setModal, reportId, third, thirds }) => {
  const [selectedThird, setSelectedThird] = useState(third);
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("language") || "english"
  );

  const updateThird = async () => {
    if (selectedThird == null) return;
    try {
      const th = selectedThird != "" ? selectedThird : "remove";
      const response = await fetch(
        config.env.API_BASE_URL + "/api/reports/" + reportId + "/third/" + th,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setModal(null);
      } else {
        console.error("Failed to update third");
      }
    } catch (error) {
      console.error("Error update third:", error);
    }
  };

  const content = {
    english: {
      heading: "Select third",
      label: "Third",
      submit: "Submit",
      cancel: "Cancel",
    },
    german: {
      heading: "Select third",
      label: "Third",
      submit: "Submit",
      cancel: "Cancel",
    },
    italian: {
      heading: "Select third",
      label: "Third",
      submit: "Submit",
      cancel: "Cancel",
    },
    czech: {
      heading: "Select third",
      label: "Third",
      submit: "Submit",
      cancel: "Cancel",
    },
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    updateThird();
  };

  const { heading, label, submit, cancel } = content[currentLanguage];

  return (
    <div className="Dash-pop">
      <section>
        <h4>{heading}</h4>
        <form onSubmit={handleFormSubmit}>
          <div>
            <div className="d-flex align-items-center">
              <label className="text-start ms-3 me-3 mb-0">{label}</label>
              <select
                className="form-select"
                style={{ height: `auto` }}
                onChange={(e) => setSelectedThird(e.target.value)}
                value={selectedThird}
                aria-placeholder="Select"
              >
                <option key={-1} value={""}>
                  --
                </option>
                {thirds.map((third, idx) => (
                  <option key={idx} value={third._id}>
                    {third.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="Dash-submit-buttons">
            <button
              type="button"
              onClick={() => setModal(false)}
              className="btn btn-secondary"
            >
              {cancel}
            </button>
            <button type="submit" className="btn btn-primary">
              {submit}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default ReportsExpertView;
